import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=405107c4&scoped=true"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"
import style0 from "./IndexComponent.vue?vue&type=style&index=0&id=405107c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405107c4",
  null
  
)

export default component.exports